import React from 'react'
import "./Footer.css"

const Footer = () => {
  return (
    <footer>
        Created by SANJIT RAM P R           2024
    </footer>

    
  )
}

export default Footer